import { getModule } from "src/system/getModule.ts";
import { ResourceEnum } from "src/constants/constants.ts";

export const getErpModules = () => [
  getModule(ResourceEnum.Language),
  getModule(ResourceEnum.VoucherSerie),
  getModule(ResourceEnum.Attribute),
  getModule(ResourceEnum.Category),
  getModule(ResourceEnum.Condition),
  getModule(ResourceEnum.Currency),
  getModule(ResourceEnum.CustomerGroup),
  getModule(ResourceEnum.Customer),
  getModule(ResourceEnum.DeliveryMethod),
  getModule(ResourceEnum.Discount),
  getModule(ResourceEnum.Manufacturer),
  getModule(ResourceEnum.Owner),
  getModule(ResourceEnum.OwnerProfile),
  getModule(ResourceEnum.PaymentMethod),
  getModule(ResourceEnum.PriceList),
  getModule(ResourceEnum.ProductGroup),
  getModule(ResourceEnum.Role),
  getModule(ResourceEnum.DeliveryService),
  getModule(ResourceEnum.DeliveryTariff),
  getModule(ResourceEnum.Supplier),
  getModule(ResourceEnum.SupplierOrder),
  getModule(ResourceEnum.ReplenishmentRun),
  getModule(ResourceEnum.SupplierAgreement),
  getModule(ResourceEnum.SupplierProcurementCondition),
  getModule(ResourceEnum.Unit),
  getModule(ResourceEnum.User),
  getModule(ResourceEnum.Country),
  getModule(ResourceEnum.Product),
  getModule(ResourceEnum.Warehouse),
  getModule(ResourceEnum.Stock),
  getModule(ResourceEnum.StockMove),
  getModule(ResourceEnum.Order),
  getModule(ResourceEnum.Picklist),
  getModule(ResourceEnum.OrderReturn),
  getModule(ResourceEnum.ProcessingTime),
  getModule(ResourceEnum.Marketplace),
  getModule(ResourceEnum.Vat),
  getModule(ResourceEnum.AccountingAccount),
  getModule(ResourceEnum.AccountingPosting),
  getModule(ResourceEnum.ConfigNumber),
  getModule(ResourceEnum.Document),
  getModule(ResourceEnum.BankAccount),
  getModule(ResourceEnum.BankTransaction),
  getModule(ResourceEnum.DocumentTemplate),
  getModule(ResourceEnum.NotificationTemplate),
  getModule(ResourceEnum.AccountingPostingPosition),
  getModule(ResourceEnum.VacantPosition),
  getModule(ResourceEnum.MarketingCompany),
  getModule(ResourceEnum.RecommendationCampaign),
  getModule(ResourceEnum.AnlassCampaign),
  getModule(ResourceEnum.MarketingCouponPool),
  getModule(ResourceEnum.IntegrationToken),
  getModule(ResourceEnum.AccountingTemplate),
  getModule(ResourceEnum.AccountingChart),
  getModule(ResourceEnum.AccountingReviewItem),
  getModule(ResourceEnum.AccountingVatReturn),
  getModule(ResourceEnum.AccountingZmReport),
  getModule(ResourceEnum.AccountingBookingSuggestion),
  getModule(ResourceEnum.AccountingBookingRule),
  getModule(ResourceEnum.AccountingMissingDocument),
  getModule(ResourceEnum.AccountingUnpostedDocument),
  getModule(ResourceEnum.BankSepa),
  getModule(ResourceEnum.NotificationRoute),
  getModule(ResourceEnum.NotificationSignature),
  getModule(ResourceEnum.NotificationSetting),
  getModule(ResourceEnum.NotificationMessage),
  getModule(ResourceEnum.EpostLetter),
  getModule(ResourceEnum.Carrier),
];
